export default {
      id: "v-menu-usage",
      viewBox: "0 0 106 512",
      url: __webpack_public_path__ + "img/svg-sprite.svg#v-menu",
      toString: function () {
        return this.url;
      }
    }